import { createMonitoringAPICall } from "../../../utils/createMonitoringAPICall";
import { AxiosError, AxiosResponse } from "axios";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { addSelectedAndDetectionTypeOnRefresh } from "./addSelectedAndDetectionTypeOnRefresh";
import { checkIfCurrentDate } from "./checkIfCurrentDate";
import { timeSlicer } from "../timeSlicer";
import { numberListToString } from "./getAlertsWithQuerry";
import { getAlertsRefresh } from "./getAlertsRefresh";
import { recordGroupAlertSnapshot } from "../AlertsStore/alertsScopeStore";
const isAlertsUrl = () => {
  const currentUrl = window.location.href;
  return currentUrl.includes("alerts");
};

export const getAlertsRefreshNoNetworkError = (
  setAlertData: Dispatcher<any>,
  navigate: NavigateFunction,
  groupId: string,
  siteId: number[],
  cameraId: number[],
  startDate: string,
  endDate: string,
  startTime: Date | null,
  endTime: Date | null,
  filterType: string,
  setSelectedRow: any,
  setRefreshingData: Dispatcher<boolean>,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  setAlertsIndexOrder: any,
  refreshInterval: any,
  setRefreshInterval: any,
  pageLoadedNumber: number,
  setSeeMoreURL: any,
  setMP4URL: any,
  setVideoClipLoading: any,
  setSelectedButtonsFilled: any,
  setAlertsToDisplay: any,
  setCurrentName: any,
  setPage: any,
  setDateOutsideRange: any,
  setFetchingFilteredData: any,
  setPageLoading: any,
  setUserFilters: any,
  userFilters: any,
  cameraOptions: any,
  siteOptions: any,
  startTimeStamp: any,
  setRefreshingToken: Dispatcher<boolean>,
  refreshingToken: boolean,
  previousLength: number,
  setBackArrowDisabled: any,
  setForwardArrowDisabled: any,
  setShowRefreshButton: any,
  setAlertsRefreshing: Dispatcher<boolean>,
  triggeredFromDetectionLabeling: boolean,
  getCurrentSelectedRowKey: () => string | null,
  setVideoProcessing?: Dispatcher<boolean>,
  useAsyncGeneration: boolean = true
) => {
  const AxiosUI = createMonitoringAPICall(``);

  let searchingPastDates = false;

  let searchParamsString = ``;

  if (startDate) {
    searchParamsString += `&start=${startDate}`;
  }

  if (endDate) {
    searchParamsString += `&end=${endDate}`;
    searchingPastDates = checkIfCurrentDate(endDate);
  }

  if (groupId) {
    if (groupId !== "undefined") {
      searchParamsString += `&group_id=${groupId}`;
    }
  }

  if (siteId[0]) {
    searchParamsString += `&customer_id=${numberListToString(siteId)}`;
  }

  if (cameraId) {
    searchParamsString += `&camera_id=${numberListToString(cameraId)}`;
  }

  if (startDate.toString() === endDate.toString() && startTime !== null) {
    searchParamsString += `&start_time=${timeSlicer(startTime)}`;
  }

  if (startDate.toString() === endDate.toString() && endTime !== null) {
    searchParamsString += `&end_time=${timeSlicer(endTime)}`;
  }

  if (userFilters.has_video) {
    searchParamsString += `&has_video=true`;
  }

  localStorage.setItem(
    "queryString",
    JSON.stringify(`${filterType}${searchParamsString}`)
  );

  const areObjectsEqual = (
    obj1: Record<string, any>,
    obj2: Record<string, any>
  ): boolean => {
    for (const key in obj1) {
      if (obj1[key] !== null && obj2[key] !== null) {
        if (obj1[key].toString() !== obj2[key].toString()) {
          return false;
        }
      }
    }
    return true;
  };

  setAlertsRefreshing(true);
  // setTimeout(
  //   () => {
  if (
    areObjectsEqual(userFilters, JSON.parse(localStorage.latestAlertFilters)) &&
    Number(pageLoadedNumber) === Number(localStorage.pageLoadedNumber) &&
    isAlertsUrl() &&
    !searchingPastDates &&
    location.href.includes("alerts")
  ) {
    setAlertsRefreshing(true);
    AxiosUI.get(`alert/?window_filter=${filterType}${searchParamsString}`).then(
      (response: AxiosResponse) => {
        recordGroupAlertSnapshot(
          response.data,
          groupId,
          filterType,
          searchParamsString
        );
        let previousTimeStamps = startTimeStamp;
        if (!response.data.records[0]) {
          setAlertData([]);
          setAlertsToDisplay(false);
          setRefreshingData(false);
        }
        if (response.data.records[0]) {
          previousTimeStamps =
            response.data.records[0].approx_capture_timestamp;
          if (
            previousTimeStamps !== startTimeStamp ||
            (previousTimeStamps === startTimeStamp &&
              response.data.records.length !== previousLength)
          ) {
            setRefreshingData(true);
            const newData = response.data;
            setAlertsToDisplay(true);
            if (
              JSON.parse(localStorage.queryString) ===
              `${filterType}${searchParamsString}`
            ) {
              setAlertData(
                addSelectedAndDetectionTypeOnRefresh(
                  newData.records,
                  setAlertsIndexOrder,
                  setSeeMoreURL,
                  setSelectedRow,
                  setSelectedAlertCameraInfo,
                  setIgnoreZonesSelectedAlert,
                  navigate,
                  setMP4URL,
                  setVideoClipLoading,
                  setSelectedButtonsFilled,
                  newData,
                  setAlertData,
                  refreshingToken,
                  setBackArrowDisabled,
                  setForwardArrowDisabled,
                  setShowRefreshButton,
                  getCurrentSelectedRowKey,
                  setVideoProcessing,
                  useAsyncGeneration
                )
              );
            }
            setRefreshingData(false);
          }
        }
        if (localStorage.tokenRefreshing === "false") {
          setTimeout(() => {
            getAlertsRefresh(
              setAlertData,
              navigate,
              groupId,
              siteId,
              cameraId,
              startDate,
              endDate,
              startTime,
              endTime,
              filterType,
              setSelectedRow,
              setRefreshingData,
              setSelectedAlertCameraInfo,
              setIgnoreZonesSelectedAlert,
              setAlertsIndexOrder,
              refreshInterval,
              setRefreshInterval,
              pageLoadedNumber,
              setSeeMoreURL,
              setMP4URL,
              setVideoClipLoading,
              setSelectedButtonsFilled,
              setAlertsToDisplay,
              setCurrentName,
              setPage,
              setDateOutsideRange,
              setFetchingFilteredData,
              setPageLoading,
              setUserFilters,
              userFilters,
              cameraOptions,
              siteOptions,
              previousTimeStamps,
              setRefreshingToken,
              refreshingToken,
              response.data.records.length,
              setBackArrowDisabled,
              setForwardArrowDisabled,
              setShowRefreshButton,
              setAlertsRefreshing,
              false,
              getCurrentSelectedRowKey,
              setVideoProcessing,
              useAsyncGeneration
            );
          }, refreshInterval);
        }
      },
      (reason: AxiosError) => {
        // if (Number(localStorage.alertsFailRetryCount) < 5) {
        //   localStorage.setItem(
        //     "alertsFailRetryCount",
        //     JSON.stringify(Number(localStorage.alertsFailRetryCount) + 1)
        //   );
        //   setTimeout(() => {
        //     getRefreshToken(
        //       navigate,
        //       getAlertsRefreshNoNetworkError(
        //         setAlertData,
        //         navigate,
        //         groupId,
        //         siteId,
        //         cameraId,
        //         startDate,
        //         endDate,
        //         startTime,
        //         endTime,
        //         filterType,
        //         setSelectedRow,
        //         setRefreshingData,
        //         setSelectedAlertCameraInfo,
        //         setIgnoreZonesSelectedAlert,
        //         setAlertsIndexOrder,
        //         refreshInterval,
        //         setRefreshInterval,
        //         pageLoadedNumber,
        //         setSeeMoreURL,
        //         setMP4URL,
        //         setVideoClipLoading,
        //         setSelectedButtonsFilled,
        //         setAlertsToDisplay,
        //         setCurrentName,
        //         setPage,
        //         setDateOutsideRange,
        //         setFetchingFilteredData,
        //         setPageLoading,
        //         setUserFilters,
        //         userFilters,
        //         cameraOptions,
        //         siteOptions,
        //         startTimeStamp,
        //         setRefreshingToken,
        //         refreshingToken,
        //         previousLength,
        //         setBackArrowDisabled,
        //         setForwardArrowDisabled,
        //         setShowRefreshButton,
        //         setAlertsRefreshing,
        //         false
        //       )
        //     );
        //   }, 10000);
        // } else {
        localStorage.setItem("alertsFailRetryCount", "0");
        setRefreshingToken(false);
        setRefreshingData(false);
        setAlertsRefreshing(false);
        // Only redirect to no-internet when the browser is actually offline.
        if (
          !navigator.onLine &&
          !window.location.pathname.includes("/no-internet")
        ) {
          navigate("/no-internet", { replace: true });
        } else {
          alert(
            "Alerts have stopped refreshing due to an Network Error. Please try refreshing page or logging out and back in."
          );
        }
        // }
      }
    );
  } else {
    setAlertsRefreshing(false);
  }
  //   },
  //   triggeredFromDetectionLabeling ? 0 : refreshInterval
  // );
};
